import React from 'react';
import './index.scss';
import '@applications-terrains/birdz-react-library/dist/esm/styles.css';
import { createRoot, Root } from 'react-dom/client';
import App from './App';
import axios from 'axios';
import * as Cookies from 'es-cookie';
import * as Sentry from '@sentry/browser';

if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    dsn: 'https://9b414db0c67b2c1816e667ae679ac4df@o4509037256900608.ingest.de.sentry.io/4509042993594448',
    environment: import.meta.env.MODE
  });
}

axios.interceptors.response.use(
  (response) => {
    if (axios.isCancel(response)) {
      //eslint-disable-next-line
      console.log(response);
      return new Promise(() => {
        // Do nothing, just to avoid unhandled promise rejection
      });
    }
    // Do something with response data
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.request.use((config: any) => {
  config.headers['Accept'] = 'application/json';
  if (!config.headers['Media-Upload']) {
    config.headers['Content-Type'] = 'application/json';
  }
  const csrfToken = Cookies.get('csrftoken');
  if (csrfToken) {
    config.headers['X-CSRFToken'] = csrfToken;
  }
  // Security: enforce relative-only URLs to prevent SSRF.
  // This is a browser-side SPA — all API calls must use relative paths (/api/...).
  // Absolute URLs are rejected to prevent open redirects or SSRF-style misuse.
  // Ref: https://cheatsheetseries.owasp.org/cheatsheets/Server_Side_Request_Forgery_Prevention_Cheat_Sheet.html
  if (config.url && /^https?:\/\//i.test(config.url)) {
    return Promise.reject(new Error(`Security: absolute URLs are not allowed (${config.url})`));
  }
  return config;
});

//Déclare la propriété sur window pour TypeScript
declare global {
  interface Window {
    _reactRoot?: Root;
  }
}

const container = document.getElementById('root');

if (!window._reactRoot && container) {
  window._reactRoot = createRoot(container);
}

window._reactRoot?.render(<App />);
